import parser from "ua-parser-js"
import AppState from "@/plugins/appstate"
import Logger from "@/plugins/logger"
import { CreateInstance, resetSessionExpiredFlag, SetHeader } from "./config"
import { getCompanyFunction, TimezoneConverter } from "./util"
import usersAPI from "./users"
import { history } from "./analystic"
import _ from "lodash"
import { session, store } from "@/api/store"
import { DevicesUpdateAPI } from "./index"
import moment from "moment"

const accessAPI = CreateInstance("access")
const ssoAccessAPI = CreateInstance("not-password-access")
const envcheckAPI = CreateInstance("temp_envcheck")
const authAPI = CreateInstance("auth")
const FileUploadAPI = CreateInstance("file_upload")
var authenticated = false
var _user = null

const auth = token => {
  if (token) return (authenticated = true)
  if (authenticated) {
    store.set("user", store.get("user"), new Date().getTime() + 10800000)
  }
  return authenticated
}

const logout = async () => {
  if (process.env.NODE_ENV !== "development") {
    try {
      const userInfo = user()
      const userId = userInfo.mail
    } catch (error) {
      console.log(error)
    }
  }

  // 보존할 데이터 백업 (로그아웃 후에도 유지되어야 하는 설정값들)
  const preservedData = {
    remember: store.get("remember"),
    viewMode: store.get("viewMode"),
    notice_skip: store.get("notice_skip"),
    lang: store.get("lang"),
    LMM_MOBILE_EXIST_AUTH: store.get("LMM_MOBILE_EXIST_AUTH"),
    LMM_MOBILE_APPLICATION: store.get("LMM_MOBILE_APPLICATION"),
    popup_skip: store.get("popup_skip"),
    networkPassFlag: store.get("networkPassFlag"),
  }

  // 모든 데이터 완전 삭제 (메모리 + IndexedDB)
  await store.reset()

  // 보존할 데이터만 다시 저장
  Object.entries(preservedData).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      store.set(key, value)
    }
  })

  // networkPassFlag, isSuperadminLogin 리셋
  store.set("networkPassFlag", 0)
  store.set("isSuperadminLogin", false)

  // 보존할 데이터를 IndexedDB에 강제 저장
  await store.flush()

  // 세션 데이터 완전 삭제
  session.remove("token")
  session.remove("refresh_token")
  sessionStorage.clear()

  // 인증 상태 해제
  authenticated = false

  return authenticated
}

const user = (value, p, noSync) => {
  if (typeof value === "string") {
    if (noSync) {
      _user[value] = p
      store.set("user", _user)
      return _user
    }
    let params = {}
    params[value] = p
    return usersAPI.put("0", params).then(resp => {
      _user[value] = p
      store.set("user", _user)
    })
  } else if (typeof value === "object") {
    const tz = TimezoneConverter("value", value.time_zone_id)
    AppState.Info.timezoneOffset = tz.offset + " minutes"
    AppState.Info.timezone = tz.name
    _user = value
    store.set("user", _user)
    return _user
  }
  return _user
}

const setPermission = (u, doNotUpdate) => {
  let perm = {}
  if (u.type === "Manager") {
    perm = {
      isAdmin: true,
      deviceMonitor: true,
      modifyInformation: true,
      useFunction: true,
      viewReport: true,
      CSRemoteControl: true,
      CSFileManager: true,
      CSDeviceManagement: true,
      CSRemoteView: true,
      CSUpdate: true,
      CSThumbnailView: true,
      CSRestart: true,
    }
  } else {
    perm.isAdmin = false
    perm.deviceMonitor = true
    perm.modifyInformation = false
    perm.useFunction = false
    perm.viewReport = false
    const authData = _.map((u.auth_val + "").split(","), v => parseInt(v, 10))
    _.each(authData, v => {
      if (v === 1) return (perm.deviceMonitor = true)
      if (v === 2) return (perm.modifyInformation = true)
      if (v === 4) return (perm.useFunction = true)
      if (v === 8) return (perm.viewReport = true)
    })
    perm.CSRemoteControl = Boolean(u.auth_remotecontrol)
    perm.CSDeviceManagement = Boolean(u.auth_devicemanagement)
    perm.CSFileManager = Boolean(u.auth_filemanager)
    perm.CSRemoteView = Boolean(u.auth_remoteview)
    perm.CSUpdate = Boolean(u.auth_update)
    perm.CSThumbnailView = Boolean(u.auth_thumbnailview)
    perm.CSRestart = Boolean(u.auth_restart)
  }

  if (!doNotUpdate) {
    AppState.perm = perm
  }

  // if (u.use_approval_function === 1 && u.use_approval) {
  //   AppState.perm.isApprover = true
  // }
  // if (u.member_type_id === 6) {
  //   AppState.perm.isSubManager = true
  // }
  if (u.use_approval_function === 1) {
    AppState.perm.isApprover = true
  }
  if (u.member_type_id === 6) AppState.perm.isSubManager = true
  return perm
}

const calcLicense = payment => {
  if (!payment || !payment.length) return null
  var today = new Date().getTime()
  var license = []
  var expireWarnings = []
  license = _.clone(payment.filter(v => !v.pay_lisence_ref))
  var lastest, lastestString
  for (var i = 0; i < license.length; i++) {
    var pk = license[i].pay_pk
    var expire = moment.utc(license[i].pay_expire).valueOf()
    var type, payDevVol
    var linked = payment.filter(v => v.pay_lisence_ref === pk)
    if (linked.length) {
      for (var n = 0; n < linked.length; n++) {
        type = linked[n].pay_type
        payDevVol = linked[n].pay_dev_vol
        var tmp = moment.utc(linked[n].pay_expire).valueOf()
        if (expire < tmp) {
          license[i].pay_expire = linked[n].pay_expire
          expire = tmp
        }
      }
      license[i].linked = linked

      if (license[i].pay_type === "Free") {
        license[i].pay_type = type
        license[i].pay_dev_vol = payDevVol
      }
    }
    if (!lastest || lastest < expire) {
      lastest = expire
      lastestString = license[i].pay_expire
    }
    license[i].expireTimeStamp = expire
    license[i].isExpired = today > expire
    license[i].expireWarning = today > expire - 604800000
    if (license[i].expireWarning && !license[i].isExpired) expireWarnings.push(license[i])
  }
  // 라이선스 만료 여부 판단.
  // license.forEach(v => {
  //   v.isExpired = true
  // })

  return {
    total: {
      count: license.length,
      // 게이트가 세팅한 AppState.license(백엔드 등급)를 우선 사용. 없으면(폴백) 배열마지막 pay_type.
      primaryProdType: AppState.license || (license.length ? license[license.length - 1].pay_type : null),
      lastestExpireDate: lastest,
      expireWarnings: expireWarnings,
      lastestExpireDateString: lastestString,
      vol: license.filter(v => !v.isExpired).reduce((sum, item) => sum + item.pay_dev_vol, 0),
    },
    list: license,
  }
}

const getOSId = name => {
  var osNames = [/Windows/i, /Ubuntu|Linux/i, /Mac/i, /Android/i, /IOS/i]
  for (var i = 0; i < osNames.length; i++) {
    if (osNames[i].test(name)) {
      return i + 1
    }
  }
  return 0
}

const getDateFmt = fmt => {
  const fmts = ["YYYY/MM/DD", "MM/DD/YYYY", "DD/MM/YYYY"]
  return fmts[fmt - 0]
}

const setDateFmt = (fmtId, fmtValue) => {
  _user.date_fmt_id = fmtId
  _user.dateFmt = fmtValue || getDateFmt(fmtId)
  store.set("user", _user, new Date().getTime() + 10800000)
  return { id: fmtId, value: _user.dateFmt }
}

// 백엔드 license 등급(또는 폴백 등급)으로 게이트 플래그 세팅. calcLicense의 AppState 부작용 대체.
// 로그인(getUserData)·새로고침(func.js checkAuth)이 공유해 게이트를 일관되게 유지한다.
const applyLicenseGate = licenseType => {
  if (!licenseType) return
  AppState.license = licenseType
  AppState.isCorporate = licenseType !== "Basic" // 상위 등급 게이트(Basic 제외, Mdm 포함)
  AppState.isMdm = licenseType === "Mdm" // MDM 전용 게이트
}

const getUserData = (token, cb, skipHistoryFlag) => {
  if (token) {
    SetHeader("token", token)
  }
  usersAPI
    .get("0")
    .then(resp => {
      const { objects } = resp.data
      // 라이선스 판정값(등급·기기수·만료일)을 백엔드 license(로그인 응답 → store.auth)로 통일.
      // list·expireWarnings 등 표시용은 calcLicense 유지. 백엔드 license 없으면(강제로그인·무라이선스) calcLicense 폴백.
      const backendLicense = (store.get("auth") || {}).license
      // applyLicenseGate를 먼저 호출해 AppState.license를 세팅 → calcLicense가 그 값을 primaryProdType으로 읽는다.
      if (backendLicense && backendLicense.license_type) {
        applyLicenseGate(backendLicense.license_type)
      }
      const calc = calcLicense(objects.pay)
      if (backendLicense && backendLicense.license_type) {
        if (calc && calc.total) {
          // primaryProdType은 calcLicense가 AppState.license로 이미 채웠음. 표시용 수치만 백엔드로 덮는다.
          calc.total.productType = backendLicense.product_type
          calc.total.vol = backendLicense.device_vol
          calc.total.lastestExpireDateString = backendLicense.latest_expire_date
        }
      } else if (calc && calc.total) {
        applyLicenseGate(calc.total.primaryProdType) // 폴백: 백엔드 없으면 calcLicense 배열마지막으로 게이트
      }
      // User() 함수에 license 등 추가 데이터를 넣는 부분.
      var userData = _.assign(
        objects,
        { license: calc },
        { permission: setPermission(objects) },
        { dateFmt: getDateFmt(objects.date_fmt_id) },
      )
      const tz = TimezoneConverter("value", userData.time_zone_id)
      AppState.Info.timezone = tz.name
      AppState.Info.timezoneOffset = tz.offset + " minutes"
      var profile = userData.mgrid.replace(/[@.]/g, "_")
      userData.profile = profile
      store.set("user", userData, new Date().getTime() + 10800000)
      _user = userData
      authenticated = true

      if (!skipHistoryFlag && token) {
        const ua = parser()
        store.set("ua", ua)
        let networkType = store.get("networkType")
        networkType = networkType.indexOf("internal") === 0 ? 0 : networkType.indexOf("external") === 0 ? 1 : 2
        let params = {
          browser: `${ua.browser.name} v-${ua.browser.major}`,
          dev_os_id: getOSId(ua.os.name),
          type_id: 1, // TYPE login
          manager_device_pk: store.get("manager_device_pk"),
          network_type: networkType,
        }
        history.post("access", params)
      }

      return cb(null, userData)
    })
    .catch(err => {
      Logger.error(err)
      return cb(err)
    })
}

const getNetworkType = (type) => {
  let networkType = 'public'
  let hostname = window.location.hostname
  
  // 원하는 도메인으로 임의 변경
  // if (hostname === "localhost" || hostname === "127.0.0.1") {
  //   hostname = "ss.linkmemine.com"
  // }
  
  if (process.env.VUE_APP_EXTERNAL_URL.split(",").includes(hostname) || type === 'user') {
    networkType = "external"
  } else if (process.env.VUE_APP_INTERNAL_URL.split(",").includes(hostname) || type === 'manager') {
    networkType = "internal"
  }
  if (["localhost", "127.0.0.1"].includes(hostname)) {
    networkType = networkType + "-dev"
  }
  
  return networkType
}

// temp_manager_device_envcheck 레코드 생성 (login_id로 company_fk 자동 설정)
const envCheckInsert = async (loginId) => {
  const result = await envcheckAPI.post("", { login_id: loginId })
  return result.data.objects
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// 원격기기 관련 login 함수
// 등록된 장치를 검증하는 기능 추가.
// @@@ 로그인 로직
const login = (authData, cb) => {
  // @ 로그인 실행
  accessAPI.post("", authData).then(async resp => {
    const { objects, status } = resp.data
    if (objects.user_type === 7) throw new Error("UserTypeIs7")
    if (status !== 200) return cb(resp.data)
    if (objects.isLogin !== "Success") return cb(resp.data)

    // 팝업에서 API 호출 시 사용할 수 있도록 토큰 먼저 저장
    session.set("token", objects.token)
    session.set("refresh_token", objects.refresh_token)
    SetHeader("token", objects.token)

    // 3STEP(OTP 인증) 성공 시 envCheck/beforeCheckLogin 건너뛰고 바로 로그인 완료
    if (authData.type === "3STEP") {
      await loginComplete(authData, objects, cb)
      return
    }

    // @ 체크 프로그램을 이용한 로그인 로직 실행
    // 에이전트 자동 로그인 설치 프로그램에서 login 기능을 사용할 때 구분을 위해 분기 추가
    if (authData.loginType) {
      cb("loadingPage")
    }
    if (authData.mode !== "Mobile") {
      let envPk = null
      if (objects.account_type === 1 && authData.loginType === "user") {
        envPk = await envCheckInsert(authData.id)
      }
      await beforeCheckLogin(authData, objects, envPk, cb)
    } else {
      await mobileBeforeCheckLogin(authData, objects, cb)
    }
  })
}

const mobileBeforeCheckLogin = async (authData, objects, cb, sso) => {
  let resp = await envcheckAPI.get("config-value-return", {
    params: {
      input_type: "mobile_registration_status",
      user_id: authData.id,
      device_id: authData.deviceId,
    },
  })
  if (resp.data.objects.registration_status === 2 || objects.account_type === 0 || objects.flag_function_manager_approval === 0) {
    // 로그인
    authData.manager_device_pk = resp.data.objects.manager_device_pk
    authData.manager_device_id = resp.data.objects.manager_device_id
    loginComplete(authData, objects, cb)
  } else if (resp.data.objects.registration_status === 0) {
    if (sso) {
      cb("duplicate")
      return
    }
    AppState.$emit("show-dialog-waiting")
  } else {
    location.href = `/#/ko/popup/mobile_manager?userId=${authData.id}&deviceId=${authData.deviceId}&os=${authData.os}&ip=${authData.ip}`
  }
}

const beforeCheckLogin = async (authData, objects, envPk, cb, sso) => {
  const { isMobile, isApplication, os } = AppState

  window.top.document.title = "LMM_SE_ENVCHK:" + envPk + ":" + authData.id + ":"

  const networkType = getNetworkType(authData.loginType)
  const testStorage = localStorage.getItem("siche-test")
  
  // if (process.env.NODE_ENV === "development" || testStorage === "true") {
  //   // console.log('개발모드 로그인 처리')
  //   objects.account_type = parseInt(process.env.VUE_APP_APPROVAL_MODE, 10)
  //   await loginComplete(authData, objects, cb)
  //   return
  // }
  
  if (networkType.indexOf("i") === 0 || objects.account_type === 0 || objects.flag_function_manager_approval === 0) {
    await loginComplete(authData, objects, cb)
    return
  }

  let WITTING_TIME = process.env.NODE_ENV === "development" ? 10 : 600
  let i = 1
  // 모바일이 아닌 경우 체크프로그램 다운로드
  if (!isMobile && envPk) {
    var a = document.createElement("a")
    if (networkType.indexOf("e") === 0) {
      a.href = "./download/LMM_SE_Launcher.exe\n"
      a.download = "LMM_SE_Launcher.exe\n"
    } else {
      a.href = "./download/LMM_SE_Launcher.exe\n"
      a.download = "LMM_SE_Launcher.exe\n"
    }
    document.body.appendChild(a)
    a.click()

    let isConditionMet = false
    // 지정한 시간동안 폴링하며, 체크 프로그램이 올바르게 환경을 체크했는지 확인함
    while (i <= WITTING_TIME && !isConditionMet) {
      await sleep(1000)
      let resp = await envcheckAPI.get("config-value-return", {
        params: {
          input_type: "env_check_status",
          pk: envPk,
        },
      })
      // if (resp.data.objects !== 0 && resp.data.objects !== null) {
      //   isConditionMet = true
      // } else {
      //   i++
      // }
      const errorMessages = {
        "-9": AppState.App.$t("access_page.unknown_error_occurred"),
        "-5": AppState.App.$t("access_page.screen_saver_disabled"),
        "-4": AppState.App.$t("access_page.start_required_process"),
        "-3": AppState.App.$t("access_page.install_and_run_antivirus"),
        "-2": AppState.App.$t("access_page.enable_windows_auto_update"),
        "-1": AppState.App.$t("access_page.comply_with_windows_policy"),
        "0": AppState.App.$t("access_page.missing_check_program"),
        "1": AppState.App.$t("access_page.check_completed"),
      }

      let errorCode = resp.data.objects
      // let alertMessage = ""

      // if (errorCode !== null) {
      //   alert("errorCode", errorCode)
      //   const errorCodeList = errorCode.split(";").filter(element => element !== "")

      //   errorCodeList.forEach(code => {
      //     let message = errorMessages[code] || "알 수 없는 오류 코드"
      //     alertMessage += `${message}\n` // 각 메시지 뒤에 줄바꿈 문자를 추가합니다.
      //   })
      // }

      if (errorCode === "success") {
        isConditionMet = true
      } else {
        if (errorCode === null) {
          i++
        } else {
          const popup = window.open(
            `/#/ko/popup/status_check?pk=${envPk}&errorCode=${errorCode}`,
            "popup-status-check",
            "width=800,height=365,scrollbars=no,resizable=no",
          )
          if (popup === null || typeof popup === "undefined") {
            cb("popup-blocked")
          } else {
            if (sso) {
              cb("logout")
              return
            }
          }
        }
      }
    }
  }

  // WITTING_TIME = process.env.NODE_ENV === "development" ? 10 : 30
  // @ 제한 시간이 지나거나, 올바르게 작동한 경우
  if (i > WITTING_TIME && !isMobile) {
    // this.$router.go(this.$router.currentRoute)
    await logout()
    alert(AppState.App.$t("access_page.user_environment_check_program"))
    try {
      cb("logout")
    } catch (error) {
      window.location.reload(true)
    }
    return null
  } else {
    let resp = await envcheckAPI.get("config-value-return", {
      params: {
        input_type: "device_exists",
        pk: envPk,
      },
    })
    // 기존 매니저 디바이스에 이미 존재함.
    if (resp.data.objects) {
      // authData.id를 통해 쿼리함.
      // 기존 매니저 디바이스에 존재하지 않기 때문에, 분기 처리 필요함.
      let resp = await envcheckAPI.get("config-value-return", {
        params: {
          input_type: "registration_status",
          user_id: authData.id,
          pk: envPk,
        },
      })
      if (resp.data.objects.registration_status === 2) {
        // 로그인
        authData.manager_device_pk = resp.data.objects.manager_device_pk
        authData.manager_device_id = resp.data.objects.manager_device_id
        await loginComplete(authData, objects, cb)
      } else if (resp.data.objects.registration_status === 0) {
        if (sso) {
          cb("duplicate")
          return
        }
        AppState.$emit("show-dialog-waiting")
      } else {
        const popup = window.open(
          `/#/ko/popup/manager?userId=${authData.id}&managerDeviceFk=${envPk}`,
          "popup-manager",
          "width=800,height=900,scrollbars=no,resizable=no",
        )
        if (popup === null || typeof popup === "undefined") {
          cb("popup-blocked")
        } else {
          popup.focus()
          if (sso) {
            cb("logout")
            return
          }
          window.location.reload(true)
        }
      }
    } else {
      // 기존 매니저 디바이스가 없으니 신규매니저 등록창을 띄워줘야한다.
      const popup = window.open(
        `/#/ko/popup/manager?userId=${authData.id}&managerDeviceFk=${envPk}`,
        "popup-manager",
        "width=800,height=900,scrollbars=no,resizable=no",
      )
      if (popup === null || typeof popup === "undefined") {
        cb("popup-blocked")
      } else {
        popup.focus()
        if (sso) {
          cb("logout")
          return
        }
        window.location.reload(true)
      }
    }
  }
}

const loginComplete = async (authData, objects, cb) => {
  // 세션 만료 플래그 리셋 (이전 세션 만료 상태 초기화)
  resetSessionExpiredFlag()

  const stored = await store.get("auth")
  const data = await getCompanyFunction("manager_session_timeout")

  // 다른 계정으로 로그인 시 기존 데이터 완전 삭제 (3STEP은 id 필드가 없으므로 건너뜀)
  if (authData.id && stored && stored.mgrid !== authData.id) {
    const preservedData = {
      remember: store.get("remember"),
      viewMode: store.get("viewMode"),
      notice_skip: store.get("notice_skip"),
      lang: store.get("lang"),
      LMM_MOBILE_EXIST_AUTH: store.get("LMM_MOBILE_EXIST_AUTH"),
      LMM_MOBILE_APPLICATION: store.get("LMM_MOBILE_APPLICATION"),
      popup_skip: store.get("popup_skip"),
    }

    // IndexedDB까지 완전히 삭제
    await store.reset()

    // 보존할 데이터만 복원
    Object.entries(preservedData).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        store.set(key, value)
      }
    })

    // 보존할 데이터를 IndexedDB에 강제 저장
    await store.flush()
  }

  // 3STEP은 loginType이 없으므로 기존 저장값 유지
  const networkType = authData.loginType ? getNetworkType(authData.loginType) : (store.get("networkType") || getNetworkType())
  store.set("auth", objects)
  store.set("networkType", networkType)
  if (authData.manager_device_pk) store.set("manager_device_pk", authData.manager_device_pk)
  if (authData.manager_device_id) {
    store.set("manager_device_id", authData.manager_device_id)
    if (process.env.VUE_APP_CHECKTOOL_DEVICE_UPDATE === 1) {
      DevicesUpdateAPI.put("", {
        input_type: "last_alive_check_time",
        device_id: authData.manager_device_id,
        last_alive_check_time: moment().format("YYYY-MM-DD HH:mm:ss"),
      })
    }
  }
  // 강제 세션로그아웃 4시간으로 설정
  store.set(
    // "expireTime",
    "forceExpireTime",
    moment()
      // .add(60, "minutes")
      // .add(4, "hours")
      .add(data, "minutes")
      .toDate(),
  )
  getUserData(objects.token, cb)
}

const requestEmail = params => {
  params.type = "resend"
  return authAPI.post("", params).then(resp => resp.data.objects)
}

const checkAuth = key => {
  let params = { key, type: "auth" }
  return authAPI.post("", params).then(resp => resp.data.objects)
}

// 요청하는 장치명과 쿼리에 필요한 user_id를 매개변수로, 현재 등록중인 장치와 요청 받은 장치를 검증하는 함수.
// login 함수가 async 형태로 만들어져있지 않아서, 콜백에 프로미스를 사용하여 작성함.
// return을 사용해서 예외처리를 할 수 밖에 없었음.. 이 함수에서 리턴을 반환하지 않으면 login 함수가 리턴을 받을 수 없기 때문.
const validateRegistrationEquipment = (data, authData) => {
  let params = {
    user_id: authData,
    request_equipment: data,
  }
}

// 로그인 중 등록된 장치에 대한 에러 핸들러.
// 에러 메시지에 따라서, 에러 형태가 구분되고, 그 구분을 통해 필요한 모달창이 출력되는 형태.
const handleLoginError = err => {
  let messageKey
  if (err.message === 'UserTypeIs7') {
    messageKey = AppState.App.$t("access_page.cannot_login_with_partner_id")
  } else if (err.message === "NotRegisteredEquipmentError") {
    messageKey = "equipment_not_registered_msg"
  } else if (err.message === "MaxDeviceLimitReachedError") {
    messageKey = "max_device_limit_reached_msg"
  }

  if (messageKey) {
    modalMassage(messageKey)
  } else {
    // Logger.log(err);
  }
}

const modalMassage = messageKey => {
  AppState.$emit("show-device-registration-dialog", {
    title: "LinkMeMine",
    context: { path: messageKey },
  })
}

export default accessAPI
export {
  auth,
  user,
  login,
  logout,
  accessAPI,
  ssoAccessAPI,
  SetHeader,
  requestEmail,
  checkAuth,
  getUserData,
  FileUploadAPI,
  setDateFmt,
  setPermission,
  calcLicense,
  applyLicenseGate,
  loginComplete,
  envCheckInsert,
  beforeCheckLogin,
  mobileBeforeCheckLogin,
  getNetworkType,
}
